import _styled2 from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { CodeCodeCorrect, CodeCodeErro, CodeCodeWarn } from '@code/icons';
import { useMemo } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Title = /*#__PURE__*/_styled2("div", process.env.NODE_ENV === "production" ? {
  target: "eisu6g30"
} : {
  target: "eisu6g30",
  label: "Title"
})("margin-top:0.75rem;font-size:1rem;font-weight:600;line-height:1.375rem; ", function (_ref) {
  var status = _ref.status;
  switch (status) {
    case 'success':
      return {
        "--tw-text-opacity": "1",
        "color": "rgba(var(--accent-success), var(--tw-text-opacity, 1))"
      };
    case 'error':
      return {
        "--tw-text-opacity": "1",
        "color": "rgba(var(--accent-error), var(--tw-text-opacity, 1))"
      };
    case 'warning':
      return {
        "--tw-text-opacity": "1",
        "color": "rgba(var(--accent-warn), var(--tw-text-opacity, 1))"
      };
    case 'info':
    default:
      return {
        "--tw-text-opacity": "1",
        "color": "rgba(var(--foreground-2), var(--tw-text-opacity, 1))"
      };
  }
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "28j1x9",
  styles: "display:flex;width:100%;flex-direction:column;align-items:center;padding-left:1.5rem;padding-right:1.5rem"
} : {
  name: "14f644-Result",
  styles: "display:flex;width:100%;flex-direction:column;align-items:center;padding-left:1.5rem;padding-right:1.5rem;label:Result;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "w339gm",
  styles: "font-size:3rem"
} : {
  name: "1iy34nr-Result",
  styles: "font-size:3rem;label:Result;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "14e9lx8",
  styles: "margin-top:0.75rem;text-align:center;font-size:14px;line-height:1.25rem;font-weight:600;--tw-text-opacity:1;color:rgba(var(--foreground-2), var(--tw-text-opacity, 1))"
} : {
  name: "1ahdwil-Result",
  styles: "margin-top:0.75rem;text-align:center;font-size:14px;line-height:1.25rem;font-weight:600;--tw-text-opacity:1;color:rgba(var(--foreground-2), var(--tw-text-opacity, 1));label:Result;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref5 = process.env.NODE_ENV === "production" ? {
  name: "1aejh3u",
  styles: "margin-top:1.5rem;width:100%"
} : {
  name: "19ap5wl-Result",
  styles: "margin-top:1.5rem;width:100%;label:Result;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var Result = function Result(props) {
  var title = props.title,
    desc = props.desc,
    extra = props.extra,
    _props$status = props.status,
    status = _props$status === void 0 ? 'info' : _props$status;
  var icon = useMemo(function () {
    if (props.icon) return props.icon;
    switch (status) {
      case 'success':
        return ___EmotionJSX(CodeCodeCorrect, null);
      case 'error':
        return ___EmotionJSX(CodeCodeErro, null);
      case 'warning':
        return ___EmotionJSX(CodeCodeWarn, null);
      default:
        return null;
    }
  }, [status]);
  return ___EmotionJSX("div", {
    css: _ref2
  }, ___EmotionJSX("div", {
    css: _ref3
  }, icon), ___EmotionJSX(Title, {
    status: status
  }, title), ___EmotionJSX("div", {
    css: _ref4
  }, desc), extra && ___EmotionJSX("div", {
    css: _ref5
  }, extra));
};